// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.user-widget[data-v-60570ec2] {\n    margin-top: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
